import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ShieldCheck, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const error = location.state?.error;

  useEffect(() => {
    const check = async () => {
      try {
        const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
        navigate("/admin", { state: { user: res.data }, replace: true });
      } catch {
        /* not signed in — show login */
      }
    };
    check();
  }, [navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-bone flex items-center justify-center px-6 pt-20">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md bg-white border border-mist p-10 lg:p-12"
      >
        <span className="w-12 h-12 bg-pine text-bone flex items-center justify-center">
          <ShieldCheck size={22} />
        </span>
        <h1 className="mt-6 font-serif font-light text-4xl tracking-tight text-pine-950">
          Doctor's Dashboard
        </h1>
        <p className="mt-3 text-sm text-sage leading-relaxed">
          Private area for Dr. Lokesh Naik G to review and manage appointment requests. Sign in with
          the authorized Google account to continue.
        </p>

        {error && (
          <div
            data-testid="login-error-alert"
            className="mt-6 flex items-start gap-3 bg-red-50 border border-red-200 text-red-800 text-sm p-4"
          >
            <AlertCircle size={18} className="mt-0.5 shrink-0" />
            {error}
          </div>
        )}

        <button
          onClick={handleGoogleLogin}
          data-testid="google-signin-button"
          className="mt-8 w-full bg-pine text-bone font-semibold text-sm tracking-wide px-8 py-4 rounded-full inline-flex items-center justify-center gap-3 hover:bg-pine-500 transition-colors duration-300"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z" />
          </svg>
          Sign in with Google
        </button>
        <p className="mt-5 text-xs text-sage text-center">
          Access is restricted to the clinic's authorized account.
        </p>
      </motion.div>
    </main>
  );
};

export default AdminLogin;
